import { motion } from 'framer-motion'

export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-deep-black flex items-center justify-center">
      <div className="flex flex-col items-center gap-8">
        {/* Logo Animation */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="relative"
        >
          {/* Hexagon Logo */}
          <div className="w-24 h-24 relative">
            <svg viewBox="0 0 100 100" className="w-full h-full">
              <defs>
                <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#B8A77D" />
                  <stop offset="50%" stopColor="#C9B896" />
                  <stop offset="100%" stopColor="#8A7D5C" />
                </linearGradient>
              </defs>
              <motion.path
                d="M50 5 L93.3 27.5 L93.3 72.5 L50 95 L6.7 72.5 L6.7 27.5 Z"
                fill="none"
                stroke="url(#goldGradient)"
                strokeWidth="2"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 1.5, ease: 'easeInOut' }}
              />
              {/* Inner B letter */}
              <motion.text
                x="50"
                y="62"
                textAnchor="middle"
                fill="#E8E2D8"
                fontSize="36"
                fontFamily="serif"
                fontWeight="600"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1, duration: 0.5 }}
              >
                B
              </motion.text>
            </svg>
          </div>
        </motion.div>

        {/* Loading Text */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="flex items-center gap-2"
        >
          <span className="text-beige text-sm tracking-widest uppercase">Cargando</span>
          <motion.span
            animate={{ opacity: [0, 1, 0] }}
            transition={{ duration: 1, repeat: Infinity }}
            className="text-gold"
          >
            ...
          </motion.span>
        </motion.div>
      </div>
    </div>
  )
}
